import { API } from "../config/AppConfig";
import { GET_PAYOR_CONTRACT, GET_COMP } from "../constants/Endpoints";

class PayorContractRepository {

  async getUploadedPayorContract (query) {
    const response = await API.get(GET_PAYOR_CONTRACT, {
        queryParams: {...query},
      });
    return response;
  }

  async getUploadedCompliance (query) {
    const response = await API.get(GET_COMP, {
        queryParams: {...query},
      });
    return response;
  }

}

const payorContractsRepository = new PayorContractRepository();
export default payorContractsRepository;